// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';

import 'jquery-parallax-scroll/js/jquery.parallax-scroll.js';
import 'jquery-nice-select/js/jquery.nice-select.min.js';

// require main js file
require('@js/index');
require('@js/slider');
require('@js/accordion');
require('@js/features-cards');
require('@js/policy-menu');
require('@js/tab');
require('@js/attach-files');
require('@js/calculator');
require('@js/video');
// require('@js/flying-elements');
